module.exports = __webpack_public_path__ + "4d5020e4d27d733edff9eeb0a681cbfd.png";